namespace $.$$ {
	export class $shm_hitalama_map_widget_float_text_md extends $.$shm_hitalama_map_widget_float_text_md {

		override content_pointerdown( event: PointerEvent ) {
			const target = event.target
			if( target instanceof Element && target.closest( 'a, [shm_hitalama_text_embed_image]' ) ) return
			return super.content_pointerdown( event )
		}

		link_favicon( next?: boolean ) {
			return this.widget().link_favicon( next )
		}

		md_download_blob() {
			return new Blob([ this.widget().text() ], { type: 'text/markdown;charset=utf-8' })
		}

		md_download_file_name() {
			const title = this.title()
				.trim()
				.replace( /[\\/:*?"<>|]+/g, '_' )
				.replace( /\.md$/i, '' ) || 'markdown'
			return `${ title }.md`
		}

		@ $mol_mem
		text() {
			const text = this.widget().text()
			if( !this.widget().title().startsWith( 'Benchmark analysis ' ) ) return text
			if( this.widget().title().startsWith( 'Benchmark analysis events ' ) ) return text
			return text.replaceAll( '{{client_id}}', this.map().Journal_snapshots()?.remote()?.client_id() ?? '' )
		}
		
	}
}
